module.exports = "/assets/images/1668003f7974a7e971ccacdecedec5fd.png";